<template>
  <div>
    <div class="myAssets" >
      <div class="titles" v-if="TemplateType == 1">
        <div class="left">
          <img class="img1" :src="'/static/logo/logo1-v'+Tversion+'.png'">
          <div class="user-box">
            <div class="account">{{userName.length>32?userName.substr(0,4)+'***'+userName.substr(-8):userName | mdName}}</div>
            <div class="uid">(UID {{userID}})</div>
          </div>
        </div>
        <img class="more-img" src="@/assets/temp1/me.png"  @click="$router.push('/user')">
      </div>
      <div class="titles" v-else></div>
      <div class="con1">
        <div class="line1">{{$t("资产")}}</div>
        <div class="line2">{{money || 0}} <span class="text1">USDT</span> </div>
      </div>
      <div class="con2">
        <div class="lineb">
          <div class="line1" @click="$router.push('/selectCurrency?type=1&url=deposit')">
            <img src="@/assets/pic11.png" class="img1" />
            <div class="text1">{{$t("充值")}}</div>
          </div>
          <div class="line1" @click="$router.push('/selectCurrency?type=1&url=withdraw')">
            <img src="@/assets/pic12.png" class="img1" />
            <div class="text1">{{$t("提现")}}</div>
          </div>
          <div class="line1" @click="$router.push('/accountRecords')" v-if="Tversion == 3">
            <img src="@/assets/pic13.png" class="img1" />
            <div class="text1">{{$t("记录")}}</div>
          </div>
          <div class="line1" @click="$router.push('/exchange')" v-else>
            <img src="@/assets/temp1/duihuan.png" class="img1" />
            <div class="text1">{{$t("兑换")}}</div>
          </div>
        </div>
      </div>
      <div class="con3">
        <div class="list" v-for="(item,k) in list">
          <div class="text1">{{item.currency | rewriteName}}</div>
          <div class="text2">
            <span class="text2-1">{{$t("可用")}}</span>
            <span class="text2-1">{{$t("折合")}}(USDT)</span>
          </div>
          <div class="text3">
            <span class="text3-1">{{item.positions | toFixed4}}</span>
            <span class="text3-1">{{item.zh | toFixed4}}(USDT)</span>
          </div>
        </div>
      </div>
    </div>
    <nav-bar :navName="'myAssets'"></nav-bar>
  </div>
</template>
<script>
import navBar from '@/components/NavBar.vue'
export default {
    name: 'myAssets',
    data () {
        return {
          theme: false,
          money: '',
          list:[],
          check: false,
          lang: 'en',
          hasData: false,
          curDataLength: 10,
          page: 1,
          userName: localStorage.getItem('userName'),
          userID: localStorage.getItem('uid'),
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
      this.money = localStorage.getItem('money');
      this.list = JSON.parse(localStorage.getItem('wallet'));
    },
    mounted() {
        this.getAsset()
    },
    methods: {
      back(){
           this.$router.push('/user')
      },
      getAsset(){
         this.$ajax.get('/web/getAsset2',{}).then((res) => {
            if(res.data.code == 0){
              let resData = res.data.data;
              this.money = (Number(resData.totalMoney)).toFixed(4);
              localStorage.setItem('money',this.money);
              if(this.check){
                  this.list = resData.list.filter((item) =>{
                      return item.positions > 0;
                  })
              }else{
                  this.list = resData.list;
              }
              localStorage.setItem('wallet',JSON.stringify(this.list));
              if(resData.list.length > 0){
                this.hasData = false;
              }else{
                this.hasData = true;
              }
            }else{
              this.$router.push('/login');
            }
        }).catch(function(err){
            console.log(err)
        })
      },
    },
    components:{
      navBar,
    },
    beforeDestroy(){

    },
    watch: {
		check:function(){
			this.getAsset();
		}
	},
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: .6rem;
        bottom: 2.2rem;
        width: 90%;
        padding: 0 .52rem;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .assets-wrap{
        position: relative;
        margin: 0 0 .24rem;
    }
    .assets-wrap .assets-box{
      padding: .6rem .56rem .7rem .6rem;
      box-sizing: border-box;
      text-align: center;
    }
    .assets-wrap .assets-box .assets-tips .text{
        color: #7d7d7d;
        font-size: .42rem;
    }
    .assets-wrap .assets-box .assets-tips .icon{
        width: .6rem;
        /* height: .36rem; */
    }
    .assets-wrap .assets-box .assets{
        padding-top: .46rem;
        color: #000;
        font-size: .83rem;
    }
    .assets-wrap .assets-box .arrow{
        width: .2rem;
    }
    .checkbox-box{
        display: flex;
        align-items: center;
    }
    .checkbox-box .text{
        padding-left: .2rem;
        color: #666;
        font-size: .42rem;
    }
    .currency-box{
      height: 9rem;
      padding: .2rem 0;
	    border-radius: 0.42rem;
      box-shadow: 0 0 0.38rem 0.19rem rgba(6, 0, 1, 0.15);
      overflow-y: scroll;
    }
    .currency-li{
      padding: .4rem .48rem;
    }
    .currency-li .currency{
        color: #000;
        font-size: .46rem;
    }
    .currency-li .currency-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .currency-li .currency-item .t1{
        color: #747474;
        font-size: .46rem;
    }
    .currency-li .currency-item .t2{
      padding-top: .2rem;
      color: #333;
      font-size: .48rem;
    }
    .money-box{
      margin-top: .6rem;
    }
    .money-box .money-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .money-box .money-head .tips{
      color: #fff;
      font-size: .56rem;
    }
    .money-box .money-head .arrow{
      width: .54rem;
    }
    .money-box .text{
      margin-top: .26rem;
      color: #747474;
      font-size: .35rem;
    }
</style>
<style type="text/css" lang="less" scoped>
  .myAssets{
    .titles{color: #333;padding: 0.5rem;position: relative;display: flex;justify-content: space-between;
        align-items: center;
      .left{display: flex;align-items: center;
        .img1{width: 1.1rem;height: 1.1rem;margin-right: 0.4rem;border-radius: 5rem;}
        .account{font-size: 0.5rem;font-weight: bold;margin-bottom: 0.05rem;}
        .uid{font-size: 0.4rem;}
      }
      .more-img{width: 0.8rem;height: 0.8rem;}
    }
    .con1{margin: 0 10px;padding: 20px 30px 50px;border-radius: 15px;
      background-image: linear-gradient(to right, #4078c7 , #2e4dcb);
      .line1{color: #fff;font-size: 16px;padding-bottom: 10px;}
      .line2{color: #fff;font-size: 28px;font-weight: bold;
        .text1{font-size: 16px;}
      }
    }
    .con2{margin-top: -30px;
      .lineb{margin: 0 10%;background-color: #fff;border-radius: 15px;display: flex;justify-content: space-around;
        padding: 15px;box-shadow: 0 0 10px 2px #00000033;
        .line1{text-align: center;
          .img1{width: 35px;}
        }
      }
    }
    .con3{padding: 10px 0 70px;
      .list{padding: 15px 10px;background-color: #fff;box-shadow: 0 0 10px 2px #00000033;margin: 15px;
        border-radius: 10px;
        .text1{font-weight: bold;font-size: 15px;color: #000;}
        .text2{display: flex;justify-content: space-between;color: #999;font-size: 12px;margin: 8px 0;}
        .text3{display: flex;justify-content: space-between;color: #333;font-size: 12px;}
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/myAssets.vue